import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'signup-report_existing_sso-action_unknown';

/**
 * This is fired when we report an existing SSO account to the user when they use that email to attempt a Sign Up.
 */
export function trackSignupReportExistingSso(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
